import Vue from "vue";
import App from "@/App.vue";
import VueTelInput from "vue-tel-input";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import Axios from "axios";
import Toasted from "vue-toasted";
import serverTranslationsMixin from "@/mixins/serverTranslations";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading);
Vue.config.productionTip = false;

Vue.config.silent = true;
Axios.defaults.xsrfCookieName = "csrftoken";
Axios.defaults.xsrfHeaderName = "X-CSRFToken";
Axios.defaults.withCredentials = true;
Vue.prototype.$http = Axios;
Vue.use(Toasted);
Vue.use(VueTelInput);
let loader = null;

Axios.interceptors.request.use(
  config => {
    if(loader) {
        loader.hide();
        loader.opacity = 0;
        loader.zIndex = -1;
    }
    loader =    Vue.$loading.show({
      color: '#00AFB9',
      loader: 'spinner',
      width: 64,
      height: 64,
      backgroundColor: '#ffffff',
      opacity: 1,
      zIndex: 99,

    });
    const token = store.getters.getToken;
    if (config.url != "/api/regions_data/get_countries/") {
       if (token) {
         config.headers["token"] = `${token}`;
       }
   }
    return config;
  },
  error => {
    if(loader){
        loader.opacity = 0;
        loader.zIndex = -1;
        loader.hide();
    }
    Vue.toasted.show(
      serverTranslationsMixin.methods.serverTranslate(
        "خطأ، برجاء الإتصال بالدعم الفني|Error, please call customer service"
      ),
      {
        type: "error",
        icon: "error_outline",
        position: "bottom-left",
        duration: 3000
      }
    );
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  res => {
    if(loader){
        loader.opacity = 0;
        loader.zIndex = -1;
        loader.hide();
    }
    store.commit("refreshToken", {
      token: res.headers.token
    });
    return res;
  },
  errors => {
    if(loader){
        loader.opacity = 0;
        loader.zIndex = -1;
        loader.hide()
    }
    if (errors.response.status === 401) {
      store.commit("logout");
      Vue.toasted.show(
        serverTranslationsMixin.methods.serverTranslate(
          errors.response.data.message
        ),
        {
          type: "error",
          icon: "error_outline",
          position: "bottom-left",
          duration: 3000
        }
      );
    } else {
      return Promise.reject(errors);
    }
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
